import React from 'react';
import { currency } from '/';

// Check for address in printed reciept
export const htmlCompanyDetails = (siteOfOrigin) => {
	if (siteOfOrigin === 'us') {
		return (<address className="text-center small">
		In Touch (US) Inc. 
		<br />350 N Orleans St.Suite 9000 N Chicago IL 60654
		<br />{ `${ currency.taxType() } No. 884-809-276` }
		<br />+1 (312) 598-2800 | hello@intouchnetworks.com
		</address>)
	} else {
		return (<address className="text-center small">
		In Touch Networks Ltd.
		<br />Registered address: 3 Hardman Square, Spinningfields, Manchester, M3 3EB
		<br />Registered in England and Wales
		<br />Company No. 05715110
		<br />{ `${ currency.taxType() } No. 884-809-276` }
		<br />Customer service: 0161 714 4179
		</address>)
	}
};



// WEBPACK FOOTER //
// src/client/helpers/addressHelpers.js